import { RootStateContext } from "@/data/RootStateProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { ChannelRemind } from "@/utils/UrlHelper";
import React from "react";
import style from "./style.less";

const Sidebar = () => {
  const { rootState, setRootStateKey } = React.useContext(RootStateContext);
  const history = useEnhancedHistory();
  let sidebarClass = style.sidebar_container;
  let sidebarBlankClass = style.sidebar_blank;
  if (rootState.sidebarOpened) {
    sidebarClass += " ";
    sidebarClass += style.sidebar_container_opened;
    sidebarBlankClass += " ";
    sidebarBlankClass += style.sidebar_blank_opened;
  }
  const backClick = () => {
    history.goBack();
  };

  const closeSidebar = () => {
    setRootStateKey("sidebarOpened", false);
  };
  const PushToUrl = (path) => {
    history.push(ChannelRemind(path));
  };
  const ReplaceToUrl = (path) => {
    closeSidebar();
    history.push(ChannelRemind(path));
  };
  return (
    <>
      <div class={sidebarClass}>
        <div class={style.sidebar_main}>
          <div class={style.sidebar_header}>
            <div class={style.back_btn} onClick={closeSidebar}></div>
          </div>
          <div class={style.sidebar_body}>
            <div class={style.sidebar_body_info}>
              <div class={style.sidebar_icon}>
                <img
                  src={require("@/assets/images/home/cbl_1.png").default}
                  style={{ width: "2rem", marginTop: "-0.3rem" }}
                />
              </div>
              <div class={style.sidebar_body_intro}>
                <div onClick={() => ReplaceToUrl("/deposit")}>
                  <span>Deposit</span>
                </div>
              </div>
            </div>
            <div class={style.sidebar_body_info}>
              <div class={style.sidebar_icon}>
                <img
                  src={require("@/assets/images/home/cbl_3.png").default}
                  style={{ width: "2rem", marginTop: "-0.3rem" }}
                />
              </div>
              <div class={style.sidebar_body_intro}>
                <div onClick={() => ReplaceToUrl("/withdraw")}>
                  <span>Withdraw</span>
                </div>
              </div>
            </div>
            <div class={style.sidebar_body_info}>
              <div class={style.sidebar_icon}>
                <img
                  src={require("@/assets/images/home/cbl_2.png").default}
                  style={{ width: "2rem", marginTop: "-0.3rem" }}
                />
              </div>
              <div class={style.sidebar_body_intro}>
                <div onClick={() => ReplaceToUrl("/invite")}>
                  <span>Promotions</span>
                </div>
              </div>
            </div>
          </div>
          <div class={style.sidebar_help}>
            <div class={style.sidebar_help_title}>Get Help</div>
            <div class={style.sidebar_help_intro}>Get quick help via calling or visiting our help center</div>
            <div class={style.sidebar_body_info}>
              <div class={style.sidebar_icon}>
                <img
                  src={require("@/assets/images/home/cbl_4.png").default}
                  style={{ width: "2rem", marginTop: "-0.3rem" }}
                />
              </div>
              <div class={style.sidebar_body_intro}>
                <div onClick={() => PushToUrl("/help")}>
                  <span>Visit the Help Center</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class={sidebarBlankClass} onClick={closeSidebar} />
    </>
  );
};

export default Sidebar;
